import React, { useState, useEffect } from "react";
import ClientAppShell from "../../components/ClientAppShell";
import ClientProjectReportsPanel from "../../components/client/ClientProjectReportsPanel";
import { useAuth } from "../../auth/AuthContext";

const Reports = () => {
  const { user } = useAuth();
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [projectId, setProjectId] = useState<string | null>(null);

  useEffect(() => {
    setProjectId(localStorage.getItem("projectId"));
  }, []);

  return (
    <ClientAppShell
      title="Reports"
      dataNav="reports"
      selectedItem={selectedItem}
      onMenuSelect={setSelectedItem}
      intro={{
        eyebrow: "Project deliverables",
        description:
          "Access advisor evaluations with analysis, comparisons, and recommendations to guide your team's next steps.",
      }}
    >
      <ClientProjectReportsPanel
        projectId={projectId}
        userId={user?.userId}
        showMembersColumn
      />
    </ClientAppShell>
  );
};

export default Reports;
